import { c as _c } from "react/compiler-runtime";
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { URLS } from '@/constants/api';
import { apiSelfCareFetcher } from '../fetcher';
import { HTTPMethod } from '@/constants/rest';
import { operations } from '@/api/skippay/generated/selfCare';
export type UpsellServiceClaimRequest = operations['publicUpsellServicesClaims']['requestBody']['content']['application/json'];
export function usePublicUpsellServicesClaims() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationFn: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useMutation(t0);
}
async function _temp(data) {
  await apiSelfCareFetcher(URLS.publicUpsellServicesClaims, {
    method: HTTPMethod.POST,
    body: data
  });
}